// extracted by mini-css-extract-plugin
module.exports = {"benefit":"Benefits__benefit__36724a0e","icon":"Benefits__icon__36724a0e","text":"Benefits__text__36724a0e"};